import { List } from '../common/list'

export const WhyRecrutersChoose = () => {
    const features = [
        'Cuts Hiring Costs By 60%',
        'Speeds Up Time-To-Hire By 40%',
        'Reconnects With Past Candidates',
        'Tracks ROI And Referral Success',
        'AI That Actually Helps, Not Hinders',
        'Works With Your Current ATS — No Switching',
    ];

    return (
        <div className='relative z-10'>
            <div className="max-w-7xl mx-auto text-white py-16 px-6 overflow-hidden py-[100px] sm:py-[250px]">
                <div className="absolute h-[500px] w-[500px] right-0 top-0">
                    <img src="/bg_pattern.png" alt="" />
                </div>

                <h2 className="relative z-10 text-3xl md:text-6xl font-medium font-oxanium mb-6">
                    Why Recruiters Choose <span className="text-[#04D1D6]">AIAURA Core</span>
                </h2>
                <div className="relative z-10 flex flex-col md:flex-row justify-between items-end gap-10">
                    <div className="">
                        <List features={features} classes={`list-disc list-inside marker:text-[#04D1D6] space-y-10 font-lato font-light text-xl lg:text-2xl`} />
                    </div>
                    <div className="w-full md:w-[585px] h-auto rounded-xl overflow-hidden">
                        <img src="/ai_aura.png" alt="AI AURA" />
                    </div>
                </div>
            </div>
            <img src="/circle2.png" alt="AI AURA" className='h-[400px] md:h-[600px] absolute z-0 top-[5%] left-[8%] overfolw-x-hidden'/>
        </div>
    )
}
